import { CommandBarButton } from "@fluentui/react";
import { useQuickFilterBarButtonStyle } from "./GridFilterBar.style";

type ToggleFilterProps = {
  title: string;
  checked: boolean;
  toggle: () => void;
  icon?: string;
};

export function ToggleFilter(props: ToggleFilterProps): JSX.Element {
  const btnStyle = useQuickFilterBarButtonStyle();

  const clickBtn = () => {
    props.toggle();
  };

  return (
    <CommandBarButton
      iconProps={{
        iconName: props.icon,
      }}
      styles={btnStyle}
      text={props.title}
      title={props.title}
      checked={props.checked}
      onClick={clickBtn}
    />
  );
}
